import { createSlice } from '@reduxjs/toolkit';
import { Notification } from 'components/CustomNotification';
import {
  AddLikes,
  // GetLikesById,
  // AddReplyLikes,
  // AddUnLikes,
  // DeleteCommentLike,
  GetbyPostlikeList,
} from '../services/LikeService';

export const LikesSlice = createSlice({
  name: 'dropdown',
  initialState: {
    // addLikes: '',
    // LikesList: [],
    // getLikes: '',
    // addCommentLikes: '',
    // addUnLikes: '',
    // commentMessage: '',
  },
  reducers: {
    // addLikes: (state, action) => {
    //   state.addLikes = [action.payload];
    // },
    // addUnLikes: (state, action) => {
    //   state.addUnLikes = [action.payload];
    // },
    // LikesList: (state, action) => {
    //   state.LikesList = [action.payload];
    // },
    // getLikes: (state, action) => {
    //   state.getLikes = [action.payload];
    // },
    // addCommentLikes: (state, action) => {
    //   state.addCommentLikes = [action.payload];
    // },
    // commentMessage: (state, action) => {
    //   state.commentMessage = action.payload;
    // },
  },
});

export const AddLikesList = (payload) => async () => {
  return AddLikes(payload)
    .then((response) => {
      // dispatch(addLikes(response));
      return response;
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
      return err;
    });
};

// export const AddUnLikesList = (payload) => async (dispatch) => {
//   AddUnLikes(payload)
//     .then((response) => {
//       dispatch(addUnLikes(response));
//     })
//     .catch((err) => {
//       Notification('warning', err.response?.data?.message);
//     });
// };

// export const AddReplyLikesList = (payload, method) => async () => {
//   AddReplyLikes(payload, method)
//     .then(() => {})
//     .catch((err) => {
//       Notification('warning', err.response?.data?.message);
//     });
// };

// export const getLikesByuserId = (data) => async (dispatch) => {
//   GetLikesById(data)
//     .then((response) => {
//       dispatch(getLikes(response.data));
//     })
//     .catch((err) => {
//       Notification('warning', err.response?.data?.message);
//     });
// };

export const handleGetbyPostlikeId = (postId) => async () => {
  return GetbyPostlikeList(postId);
};

// export const DeleteCommentLikeByuserId = (id) => async () => {
//   DeleteCommentLike(id)
//     .then((response) => {
//       Notification('success', response?.data?.message);
//     })
//     .catch((err) => {
//       Notification('warning', err.response?.data?.message);
//     });
// };

export const { getLikes, addLikes, addUnLikes } = LikesSlice.actions;
export default LikesSlice.reducer;
